import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const API = `${BACKEND_URL}/api/accounts`;

const STORAGE_EMAIL_KEY = "rx_account_email";

export function getStoredEmail() {
  try {
    return localStorage.getItem(STORAGE_EMAIL_KEY) || null;
  } catch {
    return null;
  }
}

export function setStoredEmail(email) {
  if (email) {
    localStorage.setItem(STORAGE_EMAIL_KEY, email);
  } else {
    localStorage.removeItem(STORAGE_EMAIL_KEY);
  }
}

function authHeaders() {
  const email = getStoredEmail();
  return email ? { "X-Account-Email": email } : {};
}

export async function solicitarLoginLink(email, opts = {}) {
  const { data } = await axios.post(`${API}/request-link`, {
    email,
    locale: opts.locale,
  });
  return data;
}

export async function verificarLoginLink(email, token) {
  const { data } = await axios.post(`${API}/verify-link`, { email, token });
  if (data?.email) {
    setStoredEmail(data.email);
  }
  return data;
}

export function logout() {
  setStoredEmail(null);
}

export async function getMe() {
  const { data } = await axios.get(`${API}/me`, { headers: authHeaders() });
  return data;
}

export async function guardarPasoOnboarding(n, payload) {
  const { data } = await axios.put(`${API}/me/onboarding/paso/${n}`, payload, {
    headers: authHeaders(),
  });
  return data;
}

export async function completarOnboarding() {
  const { data } = await axios.post(
    `${API}/me/onboarding/completar`,
    {},
    { headers: authHeaders() },
  );
  return data;
}
